/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { PlaceholderForContainerPreviewComponent } from '@msdyn365-commerce/core';

export default PlaceholderForContainerPreviewComponent;
